<template>
    <div>
        <div class="container-fluid featured-page-image">
            <div class="feature-header-page">
                <h1>Environmental Impact</h1>
            </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-sm-12 intro mb-5 mt-5">
              <h2>Environmental Impact</h2>
              <hr>
              <div class="environmental-statement">
                  <p>At Spectrum Digital Labels we are deeply concerned about the effect on the environment through the historical production of self adhesive labels and packaging.</p>
                  <p>With the Picojet digital press we have been able to reduce our carbon footprint by a large margin from the conventional printing processes such as UV Flexo printing which has been the industry standard in label production for many years.</p>
                  <img src="@/assets/images/Spectrum-Image.jpg" alt="spectrum environmental image">
                  <p>The Picojet digital press needs no plates. So saving on the manufacture and materials used to make the plates and all the chemicals used to clean the press when running.</p>
                  <p>Ink wastage is eradicated using digital over UV Flexo as 100% of the ink is used when printing. Saving thousands of pounds a year in wasted ink. Wasted ink with UV Flexo is flushed with chemicals to break it down into a manageable substance, and then disposed of.</p>
                  <p>The footprint is also about half what was needed to run the UV Flexo equivalent.</p>
                  <p>When printing UV Flexo with UV curing it is essential that the fumes are extracted . Knowing this, tells you what is going into the atmosphere is toxic to a degree. With Led curing there is no need to extract any fumes, making digital Led far more eco friendly and self contained with filter changes and filters being disposed of in an environmental manner.</p>
                  <p>In addition to all these positive changes for our planet, we are very pleased to announce that 50% of all our power is generated from onsite solar panels and the balance from the national grid.</p>
                  <p>We will continue to work hard to improve on this going forward.</p>
              </div>
            </div>
          </div>
        </div>
      <action-panel></action-panel>
    </div>
</template>
<script>
import ActionPanel from '@/components/partials/ActionPanel'

export default {
  name: 'EnvironmentalImpact',
  components: {ActionPanel}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/EnvironmentalImpact.vue